import Set from 'es6-set';

import { compareInitialNumberThenLexical } from '../../util/sortUtility';

const traitLabelRegExp = /trait(\d+)name/i;
const traitValueRegExp = /trait(\d+)value/i;

const variationsAreInvalid = variations => {

  // Get the count of variations that have a key matching the label
  const labelCounts = variations.reduce(
    (acc, variation) => {
      var variationTraitKeys = Object.keys(variation).filter(name => traitLabelRegExp.test(name));
      for (let key of variationTraitKeys) {
        acc[key] = (acc[key] || 0) + 1;
      }
      return acc;
    },
    {});


  let firstLabelKey = null;
  const labelKeys = Object.keys(labelCounts);
  for (let labelKey of labelKeys) {
    firstLabelKey = firstLabelKey || labelKey;
    if (labelCounts[labelKey] !== labelCounts[firstLabelKey]) {
      console.error(
        `label ${firstLabelKey} is in ${labelCounts[firstLabelKey]} variations, but label ${labelKey} is in ${labelCounts[labelKey]} variations`);
      return true;
    };
    let firstLabel = variations[0][labelKey];
    for (let variation of variations) {
      if (firstLabel !== variation[labelKey]) {
        console.error(`label mismatch for member ${labelKey}: ${firstLabel} expected but found ${variation[labelKey]}`);
        return false;
      }
    }
  }

  const valueCounts = variations.reduce(
    (acc, variation) => {
      var variationValueNames = Object.keys(variation).filter(name => traitValueRegExp.test(name));
      for (let name of variationValueNames) {
        let count = acc[name] || 0;
        acc[name] = count++;
      }
      return acc;
    },
    {});

  // Make sure each variation has a value key for each trait
  let firstValueKey = null;
  const valueKeys = Object.keys(valueCounts);
  for (let valueKey of valueKeys) {
    firstValueKey = firstValueKey || valueKey;
    if (valueCounts[valueKey] !== valueCounts[firstValueKey]) {
      console.error(
        `value key ${firstValueKey} is in ${valueCounts[firstValueKey]} variations, but value key ${valueKey} is in ${valueCounts[valueKey]} variations`);
      return true;
    }
  }

  // make sure each variation has a value key that matches each label key
  for (let labelKey of labelKeys) {
    for (let variation of variations) {
      if (typeof variation[labelKeyToValueKey(labelKey)] === 'undefined') {
        console.error(`no corresponding value for label key ${labelKey} in variation with code ${variation.Code}`);
        return true;
      }
    }
  }

  return false;
};

const getOrderedLabelKeys = variation => Object.keys(variation)
  .filter(key => traitLabelRegExp.test(key))
  .sort(compareInitialNumberThenLexical);

const labelKeyToValueKey = (labelKey) => labelKey.replace('Name', 'Value').replace('name', 'value');

const getValuesForLabel = (variations, labelKey) => {
  const valueKey = labelKeyToValueKey(labelKey);
  const valuesForLabelKey = variations.map(variation => variation[valueKey]).filter(value => value !== null);
  const uniqueValuesForLabelKey = new Set(valuesForLabelKey);
  const ret = Array.from(uniqueValuesForLabelKey);
  ret.sort(compareInitialNumberThenLexical);
  return ret;
};

const toTraits = variations => {
  const traits = [];

  // Get the object keys like 'trait2label'
  if (typeof variations[0] === 'undefined' || variations[0] === null) {
    return traits;
  }

  const labelKeys = getOrderedLabelKeys(variations[0]);

  // build the traits
  for (let labelKey of labelKeys) {

    // get the unique values for each trait in order
    const valuesForLabelKey = getValuesForLabel(variations, labelKey);

    if (valuesForLabelKey.length > 0) {
      traits.push({
        labelKey,
        label: variations[0][labelKey],
        valueKey: labelKeyToValueKey(labelKey),
        values: valuesForLabelKey
      });
    }
  }

  return traits;
};

export const mapPropsToInitialState = ({
  Variations,
  ShowBuyButton,
  ShowAddToQuoteButton,
  PriceViewModel,
  Name,
  Description,
  AssetsGroups,
  Associations,
  AddToCartEndpoint,
  ParentCategoryContentLinkId,
  Trait1Selected,
  Trait2Selected,
  CustomerType,
  SiteName,
  WishlistModel
}) => ({
  currentVariation: Variations[0],
  variations: variationsAreInvalid(Variations) ? [] : Variations,
  traits: toTraits(Variations),
  trait1Selected: Trait1Selected,
  trait2Selected: Trait2Selected,
  showBuyButton: ShowBuyButton,
  showAddToQuoteButton: ShowAddToQuoteButton,
  name: Name,
  description: Description,
  addToCartEndpoint: AddToCartEndpoint,
  userMessages: [],
  cabinetCategoryId: ParentCategoryContentLinkId,
  customerType: CustomerType,
  siteName: SiteName,
  wishlistModel: WishlistModel
});

